export default __webpack_public_path__ + "static/media/page_1.4b0afc0b.png";